import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ScoutLogService } from '../../../../shared/services/scout-log.service';
@Component({
    selector: 'app-prodlog-cub-dialog',
    templateUrl: './prodlog-cub-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProdLogCubDialogComponent {
  asset: any;
  constructor(
    public dialogRef: MatDialogRef<ProdLogCubDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public log: any,
    @Inject(MAT_DIALOG_DATA) public serial: string,
    private _logService: ScoutLogService
    ) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  clickSensors(log: any) {
    log.sensorsExpanded = !log.sensorsExpanded;
  }

  clickTestResult(log: any) {
    log.testsExpanded = !log.testsExpanded;
  }

  createAssetsDialog(log: any): void {
    this._logService.createAssetsForCubDialog(log);
  }
}
